module.exports = __webpack_public_path__ + "img/icon_endCall@2x.1ca0a2a9.png";